import React from 'react';
import { Checkbox, Autocomplete, TextField, Popper } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

interface FilterProps {
  name: string;
  label: string;
  items: any;
  placeholder?: string | React.ReactNode;
  blankOption?: boolean;
  searchQueryKey?: string;
}

function Filter({
  name,
  label,
  placeholder,
  items,
  blankOption,
  searchQueryKey = 'filter',
}: FilterProps) {
  const intl = useIntl();
  const [searchParams, setSearchParams] = useSearchParams();
  const filter = JSON.parse(searchParams.get(searchQueryKey) || '{}');
  const value = filter[name] || [];

  items = blankOption
    ? [...items, { value: 'blank', label: intl.formatMessage({ id: 'DASHBOARD.FILTERS.BLANK' }) }]
    : items;

  const onFilterUpdate = (key: string, filterValue: any) => {
    // When updating a filter, we reset the page offset
    searchParams.delete('page');
    searchParams.set(searchQueryKey, JSON.stringify({ ...filter, [key]: filterValue }));
    setSearchParams(searchParams);
  };

  const CustomPopper = (props: any) => {
    return <Popper {...props} style={{ width: 'auto', minWidth: props.style.width }} />;
  };

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={items}
      disablePortal
      slotProps={{ popper: { component: CustomPopper } }}
      getOptionLabel={(option: any) => option.label}
      value={items.filter((item: any) => value.includes(item.value))}
      onChange={(_event: any, newValue: any) =>
        onFilterUpdate(
          name,
          newValue.map((item: any) => item.value),
        )
      }
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox color="primary" checked={selected} />
          {option.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={label}
          placeholder={placeholder as string}
        />
      )}
      limitTags={1}
    />
  );
}

export default Filter;
